import { Controller } from '@hotwired/stimulus';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import DocumentEditor from '/components/DocumentEditor.vue';
import {
  Close,
  ArrowDown,
  Top,
  Bottom,
  ArrowRight,
  Refresh,
  EditPen,
  Share,
  Document,
  List,
  QuestionFilled,
} from '@element-plus/icons-vue';
import * as Sentry from '@sentry/vue';

export default class extends Controller {
  static targets = ['vueapp'];
  static values = {
    documentId: Number,
    documentTitle: String,
    currentUserId: Number,
    currentUserName: String,
    isNewDocument: Boolean,
    envName: String,
    sentryDsn: String,
  };

  connect() {
    const app = createApp(DocumentEditor, {
      documentId: this.documentIdValue,
      documentTitle: this.documentTitleValue,
      currentUserId: this.currentUserIdValue,
      isNewDocument: this.isNewDocumentValue,
    });
    if (this.envNameValue != 'development') {
      Sentry.init({
        app,
        dsn: this.sentryDsnValue,
        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        environment: this.envNameValue,
        integrations: [],
      });
      Sentry.setUser({ id: this.currentUserIdValue, username: this.currentUserNameValue });
    }
    const pinia = createPinia();
    app.component('Close', Close);
    app.component('ArrowDown', ArrowDown);
    app.component('Top', Top);
    app.component('Bottom', Bottom);
    app.component('ArrowRight', ArrowRight);
    app.component('Refresh', Refresh);
    app.component('EditPen', EditPen);
    app.component('Share', Share);
    app.component('Document', Document);
    app.component('List', List);
    app.component('QuestionFilled', QuestionFilled);
    app.use(pinia);
    app.use(ElementPlus);
    app.mount(this.vueappTarget);
  }
}
